import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Alert,
} from '@mui/material';
import {
  ErrorOutline as ErrorIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';

export default function ErrorFallback({
  title = 'Something went wrong',
  message = 'We were unable to load this page. Please try again or contact support if the problem persists.',
  onRetry,
  error,
}) {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '10px',
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '10px',
            bgcolor: 'error.lighter',
            color: 'error.main',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2,
          }}
        >
          <ErrorIcon sx={{ fontSize: 32 }} />
        </Box>

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          {title}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {message}
        </Typography>

        {error && process.env.NODE_ENV === 'development' && (
          <Alert severity="error" sx={{ mb: 3, textAlign: 'left' }}>
            {error.message || String(error)}
          </Alert>
        )}

        {onRetry && (
          <Button
            variant="contained"
            startIcon={<RefreshIcon />}
            onClick={onRetry}
          >
            Retry
          </Button>
        )}
      </Paper>
    </Box>
  );
}
